import { State } from 'model/State';
import { postToHamsClient } from 'util/mac/api/license/post';
import { fetchWithParamValidation } from 'util/fetchWithParamValidation';
import { getFromHamsClient } from 'util/mac/api/license/get';

export const archiveUnarchiveLicense = (accountId: number, isArchived: boolean, state: State) =>
  fetchWithParamValidation(
    ({ id }) => postToHamsClient(`/${id}/setArchivedStatus/${isArchived}`, state),
    {
      id: accountId,
    },
  );

export const developerLicense = (licenseId: number, state: State) =>
  fetchWithParamValidation(({ id }) => postToHamsClient(`/developer/${id}`, state), {
    id: licenseId,
  });

export const getLicenseById = (licenseId: number, state: State, ufoName: string) =>
  fetchWithParamValidation(({ id }) => getFromHamsClient(`/${id}`, state, ufoName), {
    id: licenseId,
  });
